import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '@ublique/components/LoadingModal'
import RadioButton, { RadioButtonGroup } from '@ublique/components/RadioButton'

import { first, size } from 'lodash'
import { DEFAULT_EXPORT_FORMATS, XLS } from './constants'

import './index.scss'

const ExportModal = ({
  open,
  close,
  data: { onExport, exportAllowed = DEFAULT_EXPORT_FORMATS }
}) => {
  const { t } = useTranslation(['Common', 'Shell'])
  const [fileFormat, setFileFormat] = useState()

  const handleExport = () => {
    // If the selected file format is XLS,
    // it's not necessary to include the type parameter in the request (XLS is default)
    onExport(fileFormat !== XLS && fileFormat)
    close()
  }

  const onChange = (params) => {
    setFileFormat(params)
  }

  const renderButtons = useMemo(() => {
    if (size(exportAllowed) === 0) return null

    return (
      <RadioButtonGroup
        className='export-format-btns'
        name='radio-button-group'
        defaultSelected={first(exportAllowed)}
        onChange={onChange}
      >
        {exportAllowed.map((format) => (
          <RadioButton
            key={`export-btn-${format}`}
            labelText={format}
            value={format}
            id={format}
          />
        ))}
      </RadioButtonGroup>
    )
  }, [exportAllowed, onChange])

  return (
    <Modal
      open={open}
      onRequestClose={close}
      modalHeading={t('Shell:ExportModal.TITLE')}
      className='export-service-modal'
      onRequestSubmit={handleExport}
      primaryButtonText={t('Shell:Export')}
      secondaryButtonText={t('Common:Cancel')}
      preventCloseOnClickOutside
      size='xs'
    >
      <h6 className='export-modal-subtitle'>
        {t('Shell:ExportModal.SUBTITLE')}
      </h6>
      {renderButtons}
    </Modal>
  )
}

export default ExportModal
